(function ($) {
  'use strict'
  $(function () {
    const YANDEX_METRICS_ID = 54007255
    window.reachMetricsGoal = function (event) {
      if (ym !== undefined && event !== undefined
        && typeof (ym) === typeof (Function)) {
        try {
          console.log('goal ' + event +' reached');
          ym(YANDEX_METRICS_ID, 'reachGoal', event);
        } catch (e) {
          console.error(e)
        }
      }
    }

    $(document).on('click', '[data-yandex-metrics]', function () {
      window.reachMetricsGoal($(this).data('yandex-metrics'))
    })

  })
})
(jQuery)

